import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Email = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7 9L10.13 11.5C11.16 12.32 12.85 12.32 13.88 11.5L17 9M22 8.50001C22 11.5 22 15.5 22 15.5C22 19.5 20 20.5 17 20.5H7C3.5 20.5 2 19 2 15.5V8.5C2 4.99999 3 3.5 7 3.5C7 3.5 13 3.5 18 3.5C21.5 3.5 22 5.84415 22 8.50001Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
